<template>
  <div class="overview-item" @click="$emit('selected', item.status)">
    <div class="d-flex justify-content-between">
      <div>
        <span class="overview-item__amount">{{ item.total }}</span>
        <span class="overview-item__label">{{ status.text }}</span>
      </div>
      <div>
        <img v-if="paymentStatusName && (item.status !== 'TOTAL' && item.status !== 'TOTAL_COUPON')"
        :src="require(`../../assets/img/paymentstatusimg/status-icn_${status.value}@3x.png`)"
             :alt="status.text"
        >
        <img v-else-if="item.status !== 'TOTAL' && item.status !== 'TOTAL_COUPON'"
        :src="require(`../../assets/img/status-icn_${status.value}@3x.png`)"
             :alt="status.text"
        >
      </div>
    </div>
  </div>
</template>

<script>
import getCouponStatus, { getOverViewStatus } from '../../helpers/coupon-status';

export default {
  props: ['item', 'paymentStatusName'],
  computed: {
    status() {
      if (this.paymentStatusName) {
        return getOverViewStatus(this.item.status);
      }
      return getCouponStatus(this.item.status);
    },
    statusImg() {
      if (this.paymentStatusName) {
        return getOverViewStatus(this.item.status);
      }
      return getCouponStatus(this.item.status);
    },
  },
};
</script>

<style lang="scss" scoped>
.overview-item {
  border: 1px solid #dde1e5;
  border-radius: 8px;
  background-color: #ffffff;
  cursor: pointer;
  padding: 20px 18px 20px 20px;
  max-width: 25rem;

  &:hover {
    & img {
      transform: scale(1.06);
    }
  }

  & img {
    width: 50px;
    transition: transform 0.5s;
    margin-top: 4px;

    @include respond(phone) {
      width: 43px;
    }
  }

  &__amount {
    color: #3A4047;
    font-size: 2rem;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 36px;
    display: block;
    font-family: Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  }

  &__label {
    color: #696969;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 21px;
    display: block;
    white-space: nowrap;

    @include respond(phone) {
      font-size: 12px;
    }
  }
}
</style>
